export default "__VITE_ASSET__CTNF3qJW__"